export function sleep(milliseconds: number): Promise<void> {
	return new Promise((resolve, reject) => {
		window.setTimeout(resolve, milliseconds);
	});
}